module.exports = __webpack_public_path__ + "static/media/WhipAround_ios_1_preview.4293e5a2.jpg";